import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Closing() {
  return <section className="py-20 bg-cream" data-id="element-1">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-forest-dark" data-id="element-4">
            Tienes dos caminos hoy:
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-5">
          {/* Camino A */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white border-2 border-gray-200 rounded-2xl p-8 shadow-sm relative overflow-hidden" data-id="element-6">
            <div className="absolute top-0 left-0 w-full h-2 bg-gray-300" data-id="element-7"></div>
            <div className="flex items-center mb-6" data-id="element-8">
              <div className="bg-gray-100 p-3 rounded-full mr-4" data-id="element-9">
                <AlertTriangle className="w-8 h-8 text-gray-500" data-id="element-10" />
              </div>
              <h3 className="text-2xl font-bold text-gray-700" data-id="element-11">Camino A</h3>
            </div>
            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-12">
              Seguir haciendo lo mismo, ignorando el aviso del doctor y
              arriesgándote a una enfermedad costosa que afecte tu capacidad de
              trabajar.
            </p>
          </motion.div>

          {/* Camino B */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-forest border-2 border-gold rounded-2xl p-8 shadow-xl relative overflow-hidden" data-id="element-13">
            <div className="absolute top-0 left-0 w-full h-2 bg-gold" data-id="element-14"></div>
            <div className="flex items-center mb-6" data-id="element-15">
              <div className="bg-gold/20 p-3 rounded-full mr-4" data-id="element-16">
                <CheckCircle2 className="w-8 h-8 text-gold" data-id="element-17" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-18">Camino B</h3>
            </div>
            <p className="text-cream-dark text-lg leading-relaxed" data-id="element-19">
              Invertir menos de lo que cuesta una cena afuera en un sistema que
              te dará años de salud junto a tus hijos, sin sacrificar el sabor
              de tu cultura.
            </p>
          </motion.div>
        </div>

        <div className="flex justify-center" data-id="element-20">
          <CtaButton className="text-xl py-5 px-8 md:px-12" data-id="element-21" />
        </div>
      </div>
    </section>;
}